/**
 * iOS freezes the Home-Screen icon at install time and offers no API to refresh it, so players who
 * installed before the Match15 rebrand keep the old artwork forever. The only fix is re-installing,
 * which we can merely suggest — hence the version marker below, used to tell an old install apart
 * from a fresh one.
 */

/** Bumped whenever the Home-Screen artwork changes; 2 = the Match15 rebrand, 3 = the "MATCH 15" artwork. */
export const HOME_SCREEN_ICON_VERSION = 3;

/** Query param carried by `start_url` in the manifest, so a fresh install announces its version. */
export const HOME_SCREEN_START_PARAM = 'hs';

/**
 * localStorage key holding the `hs` marker the install was launched with. The marker only lives in
 * the launch URL, and the login/sign-up redirects drop it before any view could read it — so it is
 * captured once at startup. A Home-Screen app has storage separate from Safari, so the key reliably
 * belongs to this install.
 */
export const HOME_SCREEN_INSTALL_VERSION_KEY = 'home_screen_install_version';
